// This file is auto-generated. Do not edit manually.

import { z } from "zod";

export const PropertyFieldGroup = z.enum(["propertyDetails"]);
export const PropertyFieldNames = z.enum([
  "propertyAddress",
  "propertyType",
  "propertySize",
]);

export const CreateRequestDetailSchema = z.object({
  fieldGroup: z.string().nullable(),
  fieldType: z.string(),
  fieldName: z.string(),
  fieldValue: z.string(),
});
export type CreateRequestDetail = z.infer<typeof CreateRequestDetailSchema>;

export const UpdateRequestDetailSchema =
  CreateRequestDetailSchema.partial().extend({ id: z.number() });
export type UpdateRequestDetail = z.infer<typeof UpdateRequestDetailSchema>;
